<template>
  <CCard>
        <CCardHeader>{{$t('dashBoard.cSysTodaySales.todaySales')}}</CCardHeader>
        <CCardBody><CChartBarSimple background-color="danger"/></CCardBody>        
      </CCard>
</template>
<script>
import Logger from "../../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../../router/index";
import apiWeeklySales from "./../../../services/apiWeeklySales";
import CChartBarSimple from "../../chart/CChartBarSimple"
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS } from "../../../util/constants";
import BaseConfiguration from "../../../config/base.js";
import SERVICE_URL from "../../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../../util/util";

export default {


   data () {
    return {
        
    }
   },
components:{
    CChartBarSimple
},

  
}

</script>